import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, effect } from '@angular/core';
import { Parcel } from '../../shared/models/parcel';
import { ParcelService } from '../../shared/services/parcel.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DataService } from '../../shared/services/data.service';
import { PRIMENG_MODULES } from '../../shared/primeng-imports';
import { SpinnerComponent } from "../../shared/components/spinner/spinner.component";
import { SearchComponent } from "../../shared/components/search-component/search-component.component";
import { FileViewerComponent } from "../../shared/components/file-viewer/file-viewer.component";
import { FormatDateTimePipe } from "../../pipes/format-date-time.pipe";
import { Paginator, PaginatorState } from "primeng/paginator";


@Component({
  selector: 'app-search-parcel',
  templateUrl: './search-parcel.component.html',
  styleUrl: './search-parcel.component.scss',
  standalone: true,
  imports: [...PRIMENG_MODULES, SpinnerComponent,  FileViewerComponent, FormatDateTimePipe, Paginator] //
})
export class SearchParcelComponent implements OnInit, OnChanges {
  @Input() hideOwnSearchBar: boolean = false;
  @Input() viewerActive: boolean = true;
  @Output() searchCleared = new EventEmitter<void>();
  @Output() searchResult = new EventEmitter<boolean>();
  parcel!: Parcel[];
  response: any;
  versions: any = [];
  statusData: any = [];
  images!: any[];
  selectedFileName: string = '';
  selectedFileUrl: string = '';
  itemId: string | undefined;
  isNotFound: boolean = false;
  isLoading: boolean = false;
  barcodeValue: string = '';
  products: any = [];
  first = 0;

  rows = 5;
  expandedRows: { [s: string]: boolean } = {};

  isSuperUser: boolean = false;
  deleteReason: any;
  currentRow: any;
  currentUser: any;
  showDialog: boolean = false;
  selectedParcel: any;
  selectedProduct: any;
  showRightPanel: boolean = true;

  // Archived image properties
  isArchived: boolean = false;
  archiveMessage: string = '';
  showRetrievalForm: boolean = false;
  retrievalReason: string = '';
  retrievalFormLoading: boolean = false;
  restoreStatus: string = '';
  inProgressMsg: string = '';
  inProgressHeader: string = '';
  isNormalUser: boolean = false;
  first2: number = 0;

  rows2: number = 5;
  paginationData: any = {};
  totalVersions: any;
  userClickPrev: boolean = false;
  constructor(private parcelService: ParcelService,
    private messageService: MessageService,
    public confirmationService: ConfirmationService,
    private dataService: DataService
  ) {
    effect(() => {
      const groups = this.dataService.currentGroupDataSignal();
      this.isSuperUser = groups.some(grp => grp.includes('DIA-SuperUser-'));
      this.isNormalUser = groups.some(grp => grp.includes('DIA-NormalUser-'));
    });

    effect(() => {
      this.currentUser = this.dataService.currentDataSignal();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['viewerActive']?.currentValue) {
      this.publishPrintData();
    }
  }

  ngOnInit(): void {
  }
  searchParcel() {
    if (!this.itemId) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please enter item id.' });
      return;
    }
    this.isNotFound = false;
    this.isArchived = false;
    this.isLoading = true;
    if (Object.keys(this.paginationData).length === 0) {
      this.first2 = 0;
      this.rows2 = 5;
      this.totalVersions = 0;
    }

    this.parcelService.searchItem(this.itemId, this.paginationData, this.userClickPrev).subscribe({
      next: (result) => {
        this.isLoading = false;
        this.resetUI();
        // Check if image is archived
        if (result.isRestorable === true && (!result.versions || result.versions.length === 0) && result.archiveMessage && this.isNormalUser) {

          this.isArchived = true;
          this.archiveMessage = result.archiveMessage;
          this.restoreStatus = result.restoreStatus || 'not_requested';
          this.barcodeValue = this.itemId || '';
          this.versions = [];
          this.images = [];
          this.statusData = [];

          this.searchResult.emit(true);
          return;
        }

        // Handle normal search response
        this.versions = [];
        this.images = [];
        this.paginationData = result.pagination || {};
        this.totalVersions = result.totalVersions || this.totalVersions;
        if (result.versions.length > 0) {


          this.response = result
          this.statusData = this.buildStatusHistory(result.data);

          this.barcodeValue = result.versions[0].metadata['parcel-id'];
          let order = 0
          for (let version of result.versions) {
            order++;
            version.images = [];
            version.id = order;
            const imageNames = version.metadata['image-names'].split(':');
            const imageDateTimes = version.metadata['image-datetimes'].split(':');
            const imageUrls = version.urls;
            this.barcodeValue = version.metadata['parcel-id']
            let date = imageDateTimes[0];
            for (let i = 0; i < imageNames.length; i++) {

              if (!this.isSupportedVersionUrl(imageUrls[i])) {
                continue;
              }

              version.images.push({
                imageName: imageNames[i],
                imageDateTime: imageDateTimes.length > 1 ? imageDateTimes[i] : date,
                imageUrl: imageUrls[i]
              })
              this.images.push({
                imageName: imageNames[i],
                imageDateTime: imageDateTimes.length > 1 ? imageDateTimes[i] : date,
                imageUrl: imageUrls[i]
              });
              this.expandedRows[order] = true;
            }

            this.versions.push({
              metadata: version.metadata,
            });
            version.processed = version.processed || false;
          }

          // select the first image after search
          this.selectedFileName = this.images[0]?.imageName || '';
          this.selectedFileUrl = this.images[0]?.imageUrl || '';
          this.products = result.versions;
          this.publishPrintData();
          this.searchResult.emit(true);
        }

        else {
          this.resetUI();

          if ((result.restoreStatus === 'RESTORE_REQUESTED' || result.restoreStatus === 'RESTORE_INITIATED') && this.isNormalUser) {
            this.restoreStatus = 'restore_requested';
            this.inProgressMsg = result.restoreStatus === 'RESTORE_REQUESTED' ? 'Your retrieval has been initiated successfully. Please wait <strong>5-10 minutes</strong> for the process to complete' : `Your request is currently in the admin queue and is awaiting review. If you require any assistance or would like an update on your request, please feel free to contact the <strong>${this.isNormalUser ? 'reklamation.se&#64;postnord.com' : 'admin'}</strong> for further information.`;
            this.inProgressHeader = result.restoreStatus === 'RESTORE_REQUESTED' ? 'Retrieval In Progress' : 'Retrieval Request In Progress';
            this.searchResult.emit(true);
            return;
          }
          this.isNotFound = true;
          // this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Item not found in DIA. Please try again.' });
          this.searchResult.emit(false);
        }


      },
      error: (err) => {
        this.isLoading = false;
        this.isNotFound = true;
        this.resetUI();
        // this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Item not found in DIA. Please try again.' });
        this.searchResult.emit(false);
      }
    });
  }

  isSupportedVersionUrl(url: string | undefined): boolean {
    return !!url && !/\.(txt|xml)(\?|$)/i.test(url);
  }

  resetUI() {
    this.selectedFileName = '';
    this.selectedFileUrl = '';
    this.versions = [];
    this.images = [];
    this.response = []
    this.statusData = [];
    this.barcodeValue = '';
    this.selectedFileName = '';
    this.selectedFileUrl = '';
    this.isArchived = false;
    this.archiveMessage = '';
    this.restoreStatus = '';
    this.clearPrintData();
    this.paginationData = {};
  }

  onImageClick(event: MouseEvent, image: any): void {
    event.preventDefault();
    this.selectedFileName = image.imageName;
    this.selectedFileUrl = image.imageUrl;
    this.publishPrintData();
  }

  onVersionDelete(row: any) {
    this.currentRow = row;
    this.confirmationService.confirm({
      header: 'Confirmation',
      message: `Do you want to delete ?`,
    });

  }
  onDeleteVersion(row: any) {
    let versionData = {
      "itemId": row.metadata['parcel-id'],
      "versionId": row.version,
      "deletedBy": this.currentUser,
      "reason": this.deleteReason
    }
    this.isLoading = true;
    this.parcelService.deleteVersion(versionData).subscribe({
      next: (result) => {
        this.messageService.add({ severity: 'success', summary: 'Deleted', detail: `Record deleted ` });
        this.products = this.products.filter((item: any) => item.id !== row.id)
        this.isLoading = false;
        this.confirmationService.close();
        this.checkImageViewChange(row);
        this.currentRow = '';
        this.deleteReason = '';
      },
      error: (err) => {
        console.error(`Failed to bulk update`, err);
        this.isLoading = false;
      }
    });
  }
  checkImageViewChange(row: any) {
    const changeImage = row.images.findIndex((img: any) => img.imageName === this.selectedFileName)
    if (changeImage > -1 && this.products.length > 0) {
      this.selectedFileName = this.products[0].images[0].imageName;
      this.selectedFileUrl = this.products[0].images[0].imageUrl;
      this.publishPrintData();
    }
    else {
      this.onSearchParcel(this.itemId);
    }
  }
  onSearchParcel(value: any) {
    this.itemId = value;
    if (this.itemId != '') {
      this.resetUI();
      this.searchParcel();
    } else {
      this.isNotFound = false;
      this.resetUI();
      this.searchCleared.emit();
    }
  }
  viewDetails(product: any) {
    this.showDialog = true
    this.selectedParcel = product.metadata;
    const requiredKey = ['activity', 'activity-type', 'location-id', 'location-name', 'capturedevice-id', 'capturedevice-name', 'sender']
    this.selectedProduct = Object.entries(this.selectedParcel)
      .filter(([key, value]) => requiredKey.includes(key) && value)
      .map(([key, value]) =>
      (
        {
          field: key,
          value: value
        })
      ).sort((a, b) => a.field.localeCompare(b.field));
  }
  ngOnDestroy(): void {
    this.clearPrintData();
  }

  private publishPrintData(): void {
    if (!this.viewerActive) {
      return;
    }

    this.dataService.updatePrintData({
      selectedFileName: this.selectedFileName,
      selectedFileUrl: this.selectedFileUrl,
      itemId: this.barcodeValue
    });
  }

  private clearPrintData(): void {
    if (this.viewerActive) {
      this.dataService.updatePrintData({});
    }
  }

  getStatusIcon(type: string) {
    switch (type) {
      case 'assigned': return 'pi pi-user-plus';
      case 'reprocessing': return 'pi pi-user-plus';
      case 'handled': return 'pi pi-check';
      case 'unassigned': return 'pi pi-times';
      case 'reverted': return 'pi pi-undo';
      default: return 'pi pi-info-circle';
    }
  }

  getStatusClass(type: string) {
    switch (type) {
      case 'assigned': return 'assigned';
      case 'reprocessing': return 'assigned';
      case 'handled': return 'finished';
      case 'unassigned': return 'unassigned';
      case 'reverted': return 'reverted';
      default: return 'default';
    }
  }

  buildStatusHistory(data: any[]) {
    data.sort((a, b) => b.timestamp - a.timestamp)
    const result = [];

    for (let i = 0; i < data.length; i++) {


      if (
        i > 0 &&
        (data[i - 1].status === 'assigned' || data[i - 1].status === 'reprocessing') &&
        data[i].status === 'handled' && result[result.length - 1]?.status !== 'reverted'
      ) {
        result.push({
          status: 'reverted',
          updater: data[i].updater,
          timestamp: data[i].timestamp
        });
      }
      result.push(data[i]);
    }
    return result;
  }

  // Archived Image Retrieval Methods
  openRetrievalForm(): void {
    this.retrievalReason = '';
    this.showRetrievalForm = true;
  }

  closeRetrievalForm(): void {
    this.showRetrievalForm = false;
    this.retrievalReason = '';
  }

  isRetrievalFormValid(): boolean {
    return !!(this.retrievalReason && this.retrievalReason.trim().length >= 10);
  }

  submitRetrievalRequest(): void {
    if (!this.isRetrievalFormValid()) {
      this.messageService.add({ severity: 'warn', summary: 'Validation Error', detail: 'Please provide a valid reason for retrieval (minimum 10 characters).' });
      return;
    }
    this.retrievalFormLoading = true;
    if (this.isSuperUser) {
      const requestData = {
        itemId: this.itemId,
        reason: this.retrievalReason,
        restoredBy: this.currentUser,
        isSuperAdmin: true
      };
      this.parcelService.initiateRetrievalRequest(requestData).subscribe({
        next: (result) => {
          this.retrievalFormLoading = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Your retrieval has been initiated successfully. Please wait 5-10 minutes for the process to complete',
            life: 6000
          });
          this.closeRetrievalForm();
          this.restoreStatus = 'requested';
        },
        error: (err) => {
          this.retrievalFormLoading = false;
          console.error('Failed to submit retrieval request', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to initiated request. Please try again later.'
          });
        }
      });
      return;
    }

    const requestData = {
      itemId: this.itemId,
      reason: this.retrievalReason,
      requestedBy: this.currentUser,
    };

    this.parcelService.submitRetrievalRequest(requestData).subscribe({
      next: (result) => {
        this.retrievalFormLoading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Request Submitted',
          detail: 'Your retrieval request has been submitted successfully and sent to our team for processing.',
          life: 6000
        });
        this.closeRetrievalForm();
        this.restoreStatus = 'requested';
      },
      error: (err) => {
        this.retrievalFormLoading = false;
        console.error('Failed to submit retrieval request', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to submit request. Please try again later.'
        });
      }
    });
  }

  onPageChange(event: PaginatorState) {
    this.userClickPrev = false;
    let prevPage = this.first2;
    this.first2 = event.first ?? 0;
    if (prevPage > this.first2) {
      this.userClickPrev = true;
    }

    this.rows2 = event.rows ?? 5;
    if (this.first2 === 0) {
      this.paginationData = {};
    }
    this.searchParcel();
  }
}
